/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsrefund1Inputs */

const en_ticketsrefund1 = /** @type {(inputs: Ticketsrefund1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund`)
};

const de_ticketsrefund1 = /** @type {(inputs: Ticketsrefund1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstatten`)
};

/**
* | output |
* | --- |
* | "Refund" |
*
* @param {Ticketsrefund1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsrefund1 = /** @type {((inputs?: Ticketsrefund1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsrefund1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsrefund1(inputs)
	return de_ticketsrefund1(inputs)
});
export { ticketsrefund1 as "ticketsRefund" }